/**
 * Stable CSS class names for E2E — Customer contact messages.
 */
export const CCM = {
    page: 'customer-contact-message-page',
    gridInner: 'customer-contact-message-page__grid-inner',
    datagrid: 'customer-contact-message-page__datagrid',
} as const;

export const ccmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
